var _circle, _circle2, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderAttenton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 56.5,
    r: 5,
    stroke: "#202E5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 102.5,
    r: 3,
    stroke: "#848A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 109L135.256 113.744L140 115.5L135.256 117.256L133.5 122L131.744 117.256L127 115.5L131.744 113.744L133.5 109Z",
    fill: "#E3E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12L36.2556 16.7444L41 18.5L36.2556 20.2556L34.5 25L32.7444 20.2556L28 18.5L32.7444 16.7444L34.5 12Z",
    fill: "#E3E4E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4658_37482)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 38,
    width: 84,
    height: 84,
    rx: 42,
    fill: "#E3E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7881 55.7539L83.188 89.4311H76.7942L76.194 55.7539H83.7881ZM80.0026 103.465C78.7254 103.465 77.6328 103.019 76.7249 102.126C75.817 101.219 75.3707 100.126 75.3861 98.8487C75.3707 97.5869 75.817 96.5097 76.7249 95.6172C77.6328 94.7093 78.7254 94.2553 80.0026 94.2553C81.2491 94.2553 82.3262 94.7093 83.2341 95.6172C84.142 96.5097 84.6037 97.5869 84.6191 98.8487C84.6037 99.6951 84.3806 100.472 83.9497 101.18C83.5342 101.873 82.9802 102.426 82.2878 102.842C81.5953 103.257 80.8336 103.465 80.0026 103.465Z",
    fill: "#202E5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4658_37482",
    x: 17,
    y: 15.52,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.48
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.0117647 0 0 0 0 0.345098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4658_37482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4658_37482",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAttenton);
export default __webpack_public_path__ + "static/media/placeholderAttenton.4267fdd3ef3d44dbf555b4d4987bbbe0.svg";
export { ForwardRef as ReactComponent };